// Sierra's reference data (sierra-panel.html lines 412–528, 1342–1347), as supply
// keeps it (plan 2B Assumptions 1, 2 and 7). Lists the forms offer, not limits:
// locations and hulls are free text.

/** Item categories (`SUP_CATS`, line 516). The legacy "Crates & kits" isn't needed: nothing is imported. */
export const SUP_CATS = ['Crates', 'Materials', 'Kits', 'Weapons & gear', 'Ammo & ordnance', 'Medical', 'Fuel', 'Components', 'Commodities', 'Ships & vehicles', 'Other'] as const;
export type SupCat = (typeof SUP_CATS)[number];

/** Crate sizes in SCU (`CRATE_SIZES`, line 518). Kits' box sizes take the same values. */
export const CRATE_SIZES = [1, 2, 4, 8, 16, 24, 32] as const;

/** Crate types (`CRATE_TYPES`, line 519). */
export const CRATE_TYPES = ['Ammo & ordnance', 'Repair materials', 'Fuel', 'Medical', 'Kits', 'Components', 'Commodities', 'Other'] as const;

/** Battle resources (`BATTLE_RES`, line 452). Every one is measured in SCU. */
export const BATTLE_RES = [
  { id: 's2', label: 'Size 2 ship ammo' },
  { id: 's3', label: 'Size 3 ship ammo' },
  { id: 's4', label: 'Size 4 ship ammo' },
  { id: 's5', label: 'Size 5 ship ammo' },
  { id: 'rmc', label: 'RMC' },
  { id: 'hyd', label: 'Hydrogen fuel' },
  { id: 'qt', label: 'Quantum fuel' },
] as const;
export type BattleRes = (typeof BATTLE_RES)[number]['id'];
export const BATTLE_RES_IDS = BATTLE_RES.map((resource) => resource.id) as [BattleRes, ...BattleRes[]];

/** Stockpile locations the form suggests (`LOCS`, line 413). */
export const LOCS = [
  'Area18',
  'Lorville',
  'New Babbage',
  'Orison',
  'Everus Harbor',
  'Baijini Point',
  'Port Tressler',
  'Seraphim Station',
  'Grim HEX',
  'ARC-L1',
  'CRU-L1',
  'HUR-L2',
  'MIC-L1',
  'Pyro Gateway (Stanton)',
  'Stanton Gateway (Pyro)',
  'Ruin Station',
  'Checkmate',
  'Orbituary',
  'Levski',
  'Nyx Gateway (Pyro)',
  'QT en route',
  'In hangar',
  'On the Polaris',
  'Aboard Galaxy',
] as const;

/** Hulls the ship form suggests (`SHIPS`, line 412). */
export const SHIPS = [
  'Ursa Rover',
  'Cyclone AA',
  'Cyclone RN',
  'Nova',
  'Storm',
  'Ballista',
  'ROC',
  'ROC-DS',
  'STV',
  'Mule',
  'Greycat PTV',
  'Dragonfly',
  'Pulse',
  'Fury',
  'Fury MX',
  'Fury LX',
  'Polaris',
  'Hull C',
  'Galaxy',
  'Ironclad Assault',
  'Asgard',
  'Perseus',
  'Apollo Medivac',
  'Apollo Triage',
  'Liberator',
  'Kraken',
  'Golem OX',
  'Scorpius',
  'Carrack',
  'Constellation Andromeda',
  'Corsair',
  'Cutlass Black',
  'Cutlass Red',
  'C2 Hercules',
  'M2 Hercules',
  'A2 Hercules',
  'Valkyrie',
  'Starlancer MAX',
  'Zeus Mk II CL',
  'Mercury Star Runner',
  'Hammerhead',
  'Redeemer',
  'Gladius',
  'Arrow',
  'F7C Hornet Mk II',
  'Vanguard Warden',
  'Retaliator',
  'Eclipse',
  'Ares Inferno',
  'Taurus',
  'Spirit C1',
  'Freelancer MAX',
  'Hull A',
  'Prospector',
  'MOLE',
  'Vulture',
  'Reclaimer',
  'Cyclone',
  'Ursa Medivac',
  'Nursa',
  'C8R Pisces',
  'Pisces C8X',
  'Idris-P',
] as const;

/** What a ship does (`SHIP_ROLES`, line 1345). */
export const SHIP_ROLES = ['Cargo hauler', 'Refuel', 'Rearm', 'Repair', 'Medical', 'Mining', 'Salvage', 'Refinery', 'Carrier', 'Transport', 'Escort'] as const;

/** The kinds of op a ship supports (`SHIP_OPS`, line 1342), with the panel's hints. */
export const SHIP_OPS = ['Fighter RRR', 'Ground ops', 'Combat', 'Medical', 'Logistics'] as const;
export const SHIP_OPS_HINT: Readonly<Record<(typeof SHIP_OPS)[number], string>> = {
  'Fighter RRR': 'Refuel, rearm and repair fighters',
  'Ground ops': 'Deliver vehicles, troops or munitions',
  Combat: 'Fights in the line',
  Medical: 'Medical bay or respawn',
  Logistics: 'Hauls cargo and supplies',
};

/** A ship's availability (`SHIP_AVAIL`, line 1347). */
export const SHIP_AVAILABILITY = ['Available', 'In use', 'Claim pending', 'Unavailable'] as const;
